var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list"},_vm._l((_vm.courses),function(course){return _c('div',{key:course.id,staticClass:"list__item"},[_c('CourseBasicProgressItem',{attrs:{"course":course}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }